import styled from '@emotion/styled';

const StyledStatus = styled.div`
  margin-left: 4px;
  color: #436fb1;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 150% */
`;
const StyledStatusName = styled.div`
  margin-left: 8px;
  color: var(--dk-text-primary, #34383d);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px; /* 150% */
`;

const StyledDialogTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 24px;
  font-weight: 500;
  line-height: 32px;
  font-family: var(--font-Pretendard);
`;

export { StyledStatus, StyledStatusName, StyledDialogTitle };
